import React from 'react';
import Button from 'components/Button';
import { IoMdWarning } from 'react-icons/io';
import * as toast from 'legacy/common/utils/toast';
import classNames from 'classnames';
import styles from './ProfileSettings.module.scss';
import { removeLoginData } from 'legacy/actions/userActions';
import { deleteUserAccount } from 'legacy/user/service';

interface DeleteAccountModalProps {
  onComplete: () => void;
  handleCancel: () => void;
}
const DeleteAccountModal = ({
  onComplete,
  handleCancel
}: DeleteAccountModalProps) => {
  const handleDeleteAccount = async () => {
    deleteUserAccount()
      .then(() => {
        onComplete();
        removeLoginData({ forceRedirect: true });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  return (
    <div className="p-4 flex flex-col">
      <p className="text-lg font-bold flex">
        <IoMdWarning size={24} color="#A4332A" /> &nbsp; Delete Account
      </p>
      <hr className="my-4" />
      <div className="flex gap-2 flex-col">
        <div>
          <p className="text-md font-normal text-neutral-500 mb-4 mt-5'">
            Are you sure you want to delete this account? Once deleted, you will
            no longer be able to use the app or access your data.
          </p>
        </div>
        <div className="flex flex-row justify-between gap-2 flex-row pb-2 mt-5">
          <Button
            variant="secondary"
            onClick={handleCancel}
            className={classNames(styles['cancel-button'], 'w-1/2')}
          >
            Cancel
          </Button>
          <Button
            variant="inverted"
            onClick={handleDeleteAccount}
            className={classNames(styles['delete-button'], 'w-1/2')}
          >
            Yes, Delete account
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
